module.exports = __webpack_public_path__ + "img/fashion_12.ca2c09c4.jpg";